import { render } from "./topFeaturedArticles.vue?vue&type=template&id=7c633af6"
import script from "./topFeaturedArticles.vue?vue&type=script&lang=js"
export * from "./topFeaturedArticles.vue?vue&type=script&lang=js"

import exportComponent from "/builds/elektro3-projects/elektro3-web/elektro3-komatools-web/elektro3-komatools-web-front/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__